// @agentx/sdk — A2A module
export { A2AProtocol } from './a2a'
export type { A2AConfig } from './a2a'
export const A2A_VERSION = '0.1.0'
